import {
  IIssueAutomationRuleNodeShipmentEventFieldTypeEnum,
  IIssueAutomationRuleNodeShipmentEventOperatorTypeEnum,
  IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum,
  IIssueAutomationRuleNodeShipmentInformationOperatorTypeEnum,
  IIssueAutomationRuleNodeTimeWindowFieldTypeEnum,
  IIssueAutomationRuleNodeTimeWindowOperatorTypeEnum,
  IShipmentStates,
} from 'types/graphqlTypes'
import { SHIPMENT_STATUSES } from 'constants/shipments'
import { SHIPMENT_STATE_LABELS } from '../../shipment-details/components/Header/ShipmentInfo/types'

export const SELECTION_TYPE_OPTIONS = [
  {
    label: 'Is any of the following',
    value: 'is-any',
  },
]

export const TIME_WINDOW_OPERATOR_OPTIONS = [
  {
    label: 'Is after',
    value: IIssueAutomationRuleNodeTimeWindowOperatorTypeEnum.is_after,
  },
  {
    label: 'Is before',
    value: IIssueAutomationRuleNodeTimeWindowOperatorTypeEnum.is_before,
  },
]

export const SHIPMENT_EVENT_OPERATOR_OPTIONS = [
  {
    label: 'Is Same Day',
    value: IIssueAutomationRuleNodeShipmentEventOperatorTypeEnum.is_true,
  },
]

export const SHIPMENT_EVENT_FIELD_OPTIONS = [
  {
    label: 'Pickup appointment date (same date as shipment status)',
    value: IIssueAutomationRuleNodeShipmentEventFieldTypeEnum.is_same_day_shipment,
  },
]

export const SHIPMENT_INFORMATION_OPERATOR_OPTIONS = [
  {
    label: 'Is',
    value: IIssueAutomationRuleNodeShipmentInformationOperatorTypeEnum.is_true,
  },
  {
    label: 'Is not',
    value: IIssueAutomationRuleNodeShipmentInformationOperatorTypeEnum.is_not_true,
  },
]

export const SHIPMENT_INFORMATION_FIELD_OPTIONS = [
  {
    label: 'L1 Must Track',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_shipper_l1_tracking_required,
  },
  {
    label: 'Currently Tracking',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_shipment_tracking,
  },
  {
    label: 'High Risk Shipment',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_high_risk_shipment,
  },
]

export const SHIPMENT_INFORMATION_FIELD_OPTIONS_M4 = [
  ...SHIPMENT_INFORMATION_FIELD_OPTIONS,
  {
    label: 'Drop Trailer',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_shipment_stop_drop_trailer,
  },
  {
    label: 'Trailer Number Exists',
    value:
      IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_shipment_trailer_number_present,
  },
  {
    label: 'Reefer',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_shipment_reefer,
  },
  {
    label: 'Reefer Temp Exists',
    value:
      IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_shipment_reefer_temperatures_present,
  },
]

export const SHIPMENT_INFORMATION_FIELD_OPTIONS_M5 = [
  ...SHIPMENT_INFORMATION_FIELD_OPTIONS_M4,
  {
    label: 'POD Approved',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_pod_approved,
  },
  {
    label: 'Carrier Assigned',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_carrier_assigned,
  },
  {
    label: 'Driver Assigned',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_driver_assigned,
  },
  {
    label: 'Carrier Billed',
    value: IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum.is_carrier_billed,
  },
]

export const TIME_WINDOW_AMOUNT_OPTIONS_MINUTES = [15, 30, 45].map(item => ({
  label: item.toString(),
  value: item,
}))

export const TIME_WINDOW_AMOUNT_OPTIONS_HOURS = [...Array(24).keys()].slice(1).map(item => ({
  label: item.toString(),
  value: item,
}))

export const TIME_WINDOW_AMOUNT_OPTIONS_DAYS = [1, 2, 3].map(item => ({
  label: item.toString(),
  value: item,
}))

export const TIME_WINDOW_FIELD_OPTIONS = [
  {
    label: 'Delivery Appointment Time',
    value: IIssueAutomationRuleNodeTimeWindowFieldTypeEnum.delivery_appointment_start_at,
  },
  {
    label: 'Pickup Appointment Time',
    value: IIssueAutomationRuleNodeTimeWindowFieldTypeEnum.pickup_appointment_start_at,
  },
  {
    label: 'Scheduling Task Due Time',
    value: IIssueAutomationRuleNodeTimeWindowFieldTypeEnum.scheduling_task_due_at,
  },
  {
    label: 'Tracking Task Due Time',
    value: IIssueAutomationRuleNodeTimeWindowFieldTypeEnum.tracking_task_due_at,
  },
]

export const TIME_WINDOW_UNIT_OPTIONS = [
  {
    label: 'Minutes',
    value: 'minutes',
  },
  {
    label: 'Hours',
    value: 'hours',
  },
  {
    label: 'Days',
    value: 'days',
  },
]

// Use SHIPMENT_STATUSES array, which is used to show statuses in bookings page, so that order matches between these pages
const SHIPMENT_STATUSES_VALUES = SHIPMENT_STATUSES.map(item => item.value)

export const SORTED_SHIPMENT_STATES = Object.values(IShipmentStates).sort(
  (a, b) => SHIPMENT_STATUSES_VALUES.indexOf(a) - SHIPMENT_STATUSES_VALUES.indexOf(b)
)

export const SHIPMENT_STATUS_OPTIONS = SORTED_SHIPMENT_STATES.map(state => ({
  label: SHIPMENT_STATE_LABELS[state],
  value: state,
}))

export const TWENTY_FOUR_HOURS_IN_SECONDS = 86400
export const ONE_HOUR_IN_SECONDS = 3600

export const MAX_SHIPMENT_INFO_NODES = 2

export const SHIPMENT_EVENT_ON_HOLD_AND_TENDERED_STATUS_MESSAGE =
  "The following same day Shipment Event rule will apply when a shipment moves from Submitted to On Hold or when it's the first-time On Hold."

export const SHIPMENT_EVENT_ON_HOLD_STATUS_MESSAGE =
  'The following same day Shipment Event rule will only apply when a shipment moves from Submitted to On Hold.'

export const SHIPMENT_EVENT_TENDERED_STATUS_MESSAGE =
  'The following same day Shipment Event rule will only apply to the first-time On Hold.'
